import barba from '@barba/core';
import SmoothScroll from '../singleton/SmoothScroll';

function executeInlineScript(source) {
  const code = source?.trim();

  if (!code) {
    return;
  }

  // Forminator ships per-page init as inline strings; re-run after Barba swaps the container.
  // eslint-disable-next-line no-new-func
  const runner = new Function(code);
  runner();
}

function shouldRunForminatorScript(source) {
  return (
    source.includes('forminatorFront') ||
    source.includes('forminatorLoader') ||
    source.includes('Forminator_Cform_Paginations')
  );
}

function runForminatorScriptsFromPageHtml(html) {
  if (!html) {
    return;
  }

  const doc = new DOMParser().parseFromString(html, 'text/html');
  const inlineAfter = doc.getElementById('forminator-front-scripts-js-after');

  if (inlineAfter?.textContent) {
    executeInlineScript(inlineAfter.textContent);
  }

  doc.querySelectorAll('script').forEach((script) => {
    const content = script.textContent?.trim();

    if (!content || !shouldRunForminatorScript(content)) {
      return;
    }

    executeInlineScript(content);
  });
}

export default class BarbaTransitions {
  constructor({ preloader, preloaderEnabled = true, onPageReady, onBeforeLeave }) {
    this.preloader = preloader;
    this.preloaderEnabled = preloaderEnabled;
    this.onPageReady = onPageReady;
    this.onBeforeLeave = onBeforeLeave;
    this.nextPageHtml = null;
  }

  init() {
    barba.init({
      prevent: ({ el }) => el.classList && el.classList.contains('ab-item'),
      transitions: [
        {
          name: 'default-transition',
          once: () => {
            if (!this.preloaderEnabled) {
              return;
            }

            SmoothScroll.disableScrolling();
            this.preloader.playIntro();
          },
          leave: () => {
            if (!this.preloaderEnabled) {
              return Promise.resolve();
            }

            return this.preloader.show();
          },
          afterLeave: (data) => {
            if (this.preloaderEnabled) {
              SmoothScroll.disableScrolling();
            }

            this.nextPageHtml = data.next.html;
            this.onBeforeLeave(data);
          },
          after: () => {
            if (this.preloaderEnabled) {
              this.preloader.hideAfterTransition();
            }

            runForminatorScriptsFromPageHtml(this.nextPageHtml);
            this.nextPageHtml = null;
            this.onPageReady();
          },
        },
      ],
    });
  }
}
